"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _semanticUiReact = require("semantic-ui-react");

var _MobileMenu = _interopRequireDefault(require("./components/MobileMenu"));

var _MenuItems = _interopRequireDefault(require("./components/MenuItems"));

var _InternalLink = _interopRequireDefault(require("../../atoms/InternalLink"));

require("./mobile.css");

require("./navigation.css");

var Navigation =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2["default"])(Navigation, _React$Component);

  function Navigation() {
    (0, _classCallCheck2["default"])(this, Navigation);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Navigation).apply(this, arguments));
  }

  (0, _createClass2["default"])(Navigation, [{
    key: "getAdditionalProps",
    value: function getAdditionalProps() {
      var links = this.props.links;
      var count = !this.logoHasOwnRow() ? links.length + 1 : links.length;
      return this.isEvenSpacing() ? {
        widths: count
      } : {};
    }
  }, {
    key: "getContainerClassNames",
    value: function getContainerClassNames() {
      var _this$props = this.props,
          fixed = _this$props.fixed,
          backgroundColor = _this$props.backgroundColor; // create class names

      var classNames = 'navigation-container';

      if (fixed) {
        classNames += ' navigation-container-top-fixed';
      } else {
        classNames += ' navigation-container-top';
      } // colors


      if (backgroundColor === 'primary') {
        classNames += ' navigation-primary-background';
      } else if (backgroundColor === 'secondary') {
        classNames += ' navigation-secondary-background';
      }

      return classNames;
    }
  }, {
    key: "getContainerStyle",
    value: function getContainerStyle() {
      var backgroundColor = this.props.backgroundColor;
      var additionalStyle = backgroundColor !== 'primary' && backgroundColor !== 'none' ? {
        backgroundColor: backgroundColor,
        color: 'white !important'
      } : {};
      return additionalStyle;
    }
  }, {
    key: "getPrimaryContent",
    value: function getPrimaryContent(mobile) {
      var _this$props2 = this.props,
          header = _this$props2.header,
          logo = _this$props2.logo,
          internalLinkComponent = _this$props2.internalLinkComponent;
      var content = null;
      var wrapAsMenuItem = false;

      if (logo) {
        content = _react["default"].createElement(_semanticUiReact.Image, {
          height: mobile ? 50 : 60,
          src: logo,
          centered: true
        });
      } else {
        if (mobile) {
          content = _react["default"].createElement(_semanticUiReact.Header, {
            as: "h3",
            style: {
              verticalAlign: 'middle',
              textAlign: 'center'
            }
          }, header);
        } else {
          content = this.logoHasOwnRow() ? _react["default"].createElement(_semanticUiReact.Header, {
            as: "h2",
            style: {
              textAlign: 'center',
              marginTop: 0
            }
          }, header) : _react["default"].createElement(_semanticUiReact.Header, {
            as: "h3",
            style: {
              verticalAlign: 'middle',
              textAlign: 'center'
            }
          }, header);
          wrapAsMenuItem = !this.logoHasOwnRow();
        }
      }

      var primaryContent = _react["default"].createElement(_InternalLink["default"], {
        gatsbyLink: true,
        to: "/",
        as: internalLinkComponent
      }, content);

      return wrapAsMenuItem ? _react["default"].createElement(_semanticUiReact.Menu.Item, {
        header: true,
        style: {
          textAlign: 'center'
        }
      }, primaryContent) : primaryContent;
    }
  }, {
    key: "isEvenSpacing",
    value: function isEvenSpacing() {
      var _this$props3 = this.props,
          evenSpacing = _this$props3.evenSpacing,
          primaryContentPosition = _this$props3.primaryContentPosition,
          links = _this$props3.links,
          logo = _this$props3.logo,
          header = _this$props3.header;
      var isMiddleWithEvenLinks = primaryContentPosition === 'middle' && links.length % 2 === 0;
      var noHeaderOrLogo = header.length === 0 && logo.length === 0;
      return evenSpacing && (isMiddleWithEvenLinks || primaryContentPosition === 'top') || noHeaderOrLogo;
    }
  }, {
    key: "logoHasOwnRow",
    value: function logoHasOwnRow() {
      var primaryContentPosition = this.props.primaryContentPosition;
      return primaryContentPosition === 'top';
    }
  }, {
    key: "renderMenuItems",
    value: function renderMenuItems() {
      var _this$props4 = this.props,
          links = _this$props4.links,
          linksAs = _this$props4.linksAs,
          primaryContentPosition = _this$props4.primaryContentPosition,
          header = _this$props4.header,
          logo = _this$props4.logo,
          internalLinkComponent = _this$props4.internalLinkComponent;

      if (primaryContentPosition === 'top' || !header && !logo) {
        return _react["default"].createElement(_MenuItems["default"], {
          linksAs: linksAs,
          links: links,
          internalLinkComponent: internalLinkComponent
        });
      }

      if (primaryContentPosition === 'middle' && links.length % 2 === 0) {
        var linksLength = links.length;
        var linksPivot = Math.floor(linksLength / 2);
        return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(_MenuItems["default"], {
          internalLinkComponent: internalLinkComponent,
          linksAs: linksAs,
          links: links.slice(0, linksPivot)
        }), _react["default"].createElement(_semanticUiReact.Menu.Item, null, this.getPrimaryContent()), _react["default"].createElement(_MenuItems["default"], {
          internalLinkComponent: internalLinkComponent,
          linksAs: linksAs,
          links: links.slice(linksPivot)
        }));
      }

      return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(_semanticUiReact.Menu.Item, null, this.getPrimaryContent()), _react["default"].createElement(_semanticUiReact.Menu.Menu, {
        position: "right"
      }, _react["default"].createElement(_MenuItems["default"], {
        internalLinkComponent: internalLinkComponent,
        linksAs: linksAs,
        links: links
      })));
    }
  }, {
    key: "renderNavContainer",
    value: function renderNavContainer(child) {
      if (this.logoHasOwnRow()) {
        return _react["default"].createElement("div", {
          style: this.getContainerStyle()
        }, _react["default"].createElement(_semanticUiReact.Segment, {
          className: this.getContainerClassNames()
        }, _react["default"].createElement(_semanticUiReact.Menu.Item, null, this.getPrimaryContent()), child));
      }

      return _react["default"].createElement("div", {
        className: this.getContainerClassNames(),
        style: this.getContainerStyle()
      }, child);
    }
  }, {
    key: "renderTopNav",
    value: function renderTopNav() {
      var _this$props5 = this.props,
          bordered = _this$props5.bordered,
          fixed = _this$props5.fixed;
      var menuFixed = !this.logoHasOwnRow() && fixed ? 'top' : null;

      if (this.logoHasOwnRow()) {
        var onlyTopPositionStyle = {
          border: 'none',
          boxShadow: 'none',
          padding: '0 20%'
        };
        return this.renderNavContainer(_react["default"].createElement("div", {
          style: onlyTopPositionStyle
        }, _react["default"].createElement(_semanticUiReact.Menu, (0, _extends2["default"])({
          stackable: true,
          vertical: false,
          borderless: !bordered,
          size: "massive",
          fixed: menuFixed
        }, this.getAdditionalProps()), this.renderMenuItems())));
      }

      return this.renderNavContainer(_react["default"].createElement(_semanticUiReact.Menu, (0, _extends2["default"])({
        stackable: true,
        vertical: false,
        borderless: !bordered,
        size: "massive",
        fixed: menuFixed
      }, this.getAdditionalProps()), this.renderMenuItems()));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
          linksAs = _this$props6.linksAs,
          links = _this$props6.links,
          centerMobileNavItems = _this$props6.centerMobileNavItems,
          primaryContentPosition = _this$props6.primaryContentPosition,
          backgroundColor = _this$props6.backgroundColor,
          internalLinkComponent = _this$props6.internalLinkComponent;
      var nav = this.renderTopNav();
      return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement("div", {
        className: "desktop-nav"
      }, nav), _react["default"].createElement("div", {
        className: "mobile-nav"
      }, _react["default"].createElement(_MobileMenu["default"], {
        internalLinkComponent: internalLinkComponent,
        centerMobileNavItems: centerMobileNavItems,
        logo: this.getPrimaryContent(true),
        position: primaryContentPosition,
        links: links,
        linksAs: linksAs,
        className: this.getContainerClassNames(),
        backgroundColor: backgroundColor
      })));
    }
  }]);
  return Navigation;
}(_react["default"].Component);

exports["default"] = Navigation;
Navigation.propTypes = {
  links: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    pageTitle: _propTypes["default"].string.isRequired,
    slug: _propTypes["default"].string.isRequired,
    internal: _propTypes["default"].bool.isRequired,
    emphasis: _propTypes["default"].bool,
    inverted: _propTypes["default"].bool,
    as: _propTypes["default"].oneOf([_propTypes["default"].string, _propTypes["default"].element])
  })).isRequired,
  backgroundColor: _propTypes["default"].string,
  bordered: _propTypes["default"].bool,
  centerMobileNavItems: _propTypes["default"].bool,
  evenSpacing: _propTypes["default"].bool,
  fixed: _propTypes["default"].bool,
  header: _propTypes["default"].string,
  linksAs: _propTypes["default"].oneOf(['h3', 'h4', 'h5', 'h6', 'text']),
  logo: _propTypes["default"].string,
  internalLinkComponent: _propTypes["default"].element,
  primaryContentPosition: _propTypes["default"].oneOf(['top', 'left', 'middle']),
  primaryContentCentered: _propTypes["default"].bool
};
Navigation.defaultProps = {
  backgroundColor: 'none',
  bordered: false,
  centerMobileNavItems: true,
  evenSpacing: false,
  fixed: false,
  header: '',
  linksAs: 'h4',
  logo: '',
  internalLinkComponent: 'a',
  primaryContentPosition: 'left',
  primaryContentCentered: false
};
Navigation.propOptions = {
  backgroundColor: ['primary', 'none']
};
Navigation.dataPropsMap = {};